import React from "react";
import "./IneedToContents.css"

class IneedToContents extends React.Component {

    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the NormalForms component
        this.state =
            {
                contents: this.props.value
            };

        }

        onNameSpacesClick = () =>
        {
            this.props.switcher(1);
        }

        

        onUniqueClick = () =>
        {
            this.props.switcher(2);
        }

        onPriorityClick = () =>
        {
            this.props.switcher(3);
        }

         onEncryptClick = () =>
        {
            this.props.switcher(4);
        }


    render() {
        return (

            <div className='WhurzitContents scroll-div'>

            <h1>Overview</h1>

            	<p>iNeed2 is a ToDo list that is meant to be copied from one directory to another
                on a user's computer.  iNeed2 webpages contain to do lists that are unique to
                the directory where iNeed2 resides. </p>

            <p><i>Click on a feature of iNeed2 to learn more about that feature.</i></p>

            <p className="Bullet"> ▶      </p>
            <p className="ContentItem" onClick={this.onNameSpacesClick}>Namespaces</p>
            <br/>
            <br/>
            

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onUniqueClick}>Uniqueness and Storage</p>
            <br/>
            <br/>
            
            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onPriorityClick}>Priority</p>
            <br/>
            <br/>

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onEncryptClick}>Encryption</p>
            <br/>
            

             
  
            </div>

        )

    }

}

export default IneedToContents;



// WEBPACK FOOTER //
// ./src/components/iNeed2_Slides/IneedToContents.js